import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { caseToOperateSlice } from "../redux/cto/caseToOperate/slice";
import { ctoSlice } from "../redux/cto/steps/slice";
import { matrixSlice } from "../redux/matrix/slice";
import type { State } from "../types";
import { applicationSlice } from "./application/slice";
import { notificationSlice } from "./notification/slice";
import { userSlice } from "./user/slice";
import { usersSlice } from "./users/slice";
import { supportRequestsSlice } from "./supportRequests/slice";
import { tagsAndWorkOrdersSlice } from "./tagsAndWorkOrders/slice";
import { bowtieSlice } from "./bowtie/slice";
import { vesselSlice } from "./vessel/slice";

const rootReducer = combineReducers({
  application: applicationSlice.reducer,
  caseToOperate: caseToOperateSlice.reducer,
  cto: ctoSlice.reducer,
  notification: notificationSlice.reducer,
  supportRequests: supportRequestsSlice.reducer,
  tagsAndWorkOrders: tagsAndWorkOrdersSlice.reducer,
  user: userSlice.reducer,
  users: usersSlice.reducer,
  matrix: matrixSlice.reducer,
  bowtie: bowtieSlice.reducer,
  vessel: vesselSlice.reducer,
});

export const getStore = (preloadedState?: Partial<State>) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
    preloadedState,
  });
